module.exports = "/assets/data/fd94b884f93e33c149353bbc9756a72c-WD6.data.json";